import React, { useEffect,  useState } from "react";

import styled from "styled-components";
import { getPopmenuInfo } from '@/api/base'
import Header from '@/components/Header'
import bridge from '@/config/JSbridge'
import smoothscroll from 'smoothscroll-polyfill';
import  bwmodel from '@/config/bwmodel'

// import ModalView from '@/components/modal-view'

// import OpenApp from './../../components/OpenApp';
import closeIcon from '@/img/activity22/close.png'
import { connect } from 'react-redux';
import { Toast } from "antd-mobile";
import h5Share from '@/utils/h5Share'

import { handleUploadTrace } from '@/utils'
let timer;
// import { ModalContainer } from "../sku-exchange/style";
const Active_121 = ({token}) => {
  const [showModal,setShowModal] = useState(false)
  const [count, setCount] = useState(0);
  const [showPopMenu, setShowPopMenu] = useState(false);
  const [tips,setTips] = useState('00时00分00秒');
  const isStorm = bwmodel.app === 'storm';
  const shareUrl = `#/active_${121}`

  
  let getData = () => {
    getPopmenuInfo({}).then(res => {
      clearInterval(timer);
      setShowPopMenu(res.showPopMenu);
      // setShowPopMenu(false);

      if(res.showPopMenu) {
 
        const endTime = res.firstClickTime + 24*60*60*1000;
    
        let residueTime = endTime - new Date().getTime();

        timer = setInterval(()=> {
          residueTime = residueTime - 1000;
          console.log(residueTime);
          if(residueTime<=0) {
            setShowPopMenu(false);
          }
          // console.log(Math.floor(residueTime/1000)<=0);
          const time = Math.floor(residueTime/1000)>=0 ? Math.floor(residueTime/1000) : 0;
  
          var h=0,m=0,s=0;
          s = time%60;
  
          m = ((time-s)/60)%60;
          h = ((time-m*60-s)/60)/60;
     
          setTips(`${h.toString().padStart(2, '0')}时${m.toString().padStart(2, '0')}分${s.toString().padStart(2, '0')}秒`)
         
        },1000)
      }
     
  
    }).catch((error) => {

      let res = error.response
      if (res && res.status === 401) {
        // setIsLogin(false);
        
        Toast.info('请先登录')
      }
    })
  }  

  useEffect(() => {

    handleUploadTrace('ActivityPagelyuan')

    h5Share.main({ 
      title: `【限时领取】专享9大炒股神器福利`,
      desc: '福利包含“精选研报、短线挖掘、波段助手、红绿波段、趋势拐点、跳空异动。。。”等等10多种权益内容，限时领取。',
      link: process.env.REACT_APP_DEMAND_URL + 'active_121',
      thumbUrl: 'https://file.wogoo.com/app/logo/logo6.png',
      wxShare:{
        shareData:{
          imgUrl: 'https://file.wogoo.com/app/logo/logo6.png'
        }
      },
      shareData:{
        imgUrl: 'https://file.wogoo.com/app/logo/logo6.png'
      }
    })
    smoothscroll.polyfill();
    
    getData();
   
  }, [])



  const handleLeftClick = () => {
  
    const bool =  showPopMenu && (count===0); 
    if(bool) {
      setShowModal(true);
    } else {
      console.log('返回');
      bridge.callHandler('nativeEvent', {event: 'close', params: {
        isDelete: false
      }}, () => {})
    }

  }

  const linkToDownload = () => {
    // 埋点
    // handleUploadTrace('7th-anniversary_link-download', 'click')
    //
    window.location.href = "https://m.wogoo.com/app/download/wogoo_client/index.html"
  }

  const handleLogin = () => {
    bridge.callHandler(
      'nativeEvent',
      {
        event: 'login',
        params: {
          refreshOnBack: true
        }
      },
      () => {}
    );
  }

  const handleUnlock = () => {  //
    if(!showPopMenu) {
      return Toast.info('活动已经结束')
    }
    // 埋点
    if (!isStorm) {
      linkToDownload()
      return
    }
    if (!token) {
      handleLogin()
      return
    }
    const goods  = {
      skuPrice: 0,
      skuId: 150,
      goodsName: '惊喜会员',  // 此地写死，如复制需要注意
      spuId: '1'     // 此地写死，如复制需要注意
    }

 

    bridge.callHandler('nativeEvent', {
      event: 'halfScreenPay',
      params: {
        price: `${goods.skuPrice}`,
        activityTitle: goods.goodsName,
        skuId: `${goods.skuId}`,
        orderType: `${goods.spuId}`
      },
    }, (params) => {
      try {
        const info = JSON.parse(params)
        if (info && info.params.result) {
          // initPage()

          bridge.callHandler('nativeEvent', {event: 'close', params: {
            isDelete: false
          }}, () => {})
          
          setShowModal(false);
          getData();
        
        }
      } catch (error) {
        //
      }
    })
  }

  const closeModal = () => {
    let num = count + 1;
    setCount(num);

    setShowModal(false);
    // 返回上一层
    bridge.callHandler(
      'nativeEvent',
      {
        event: 'popPage',
        params: {
          index: '-1'
        }
      },
      () => {
        
      }
    );
    
  }


  function handleScroll(e) {
    // let footer = document.getElementById('footer');
    // if(footer) {
    //   if(window.scrollY >=20) {
    //     footer.classList.add('footer-freeclass-block');
    //   }else {
    //     footer.classList.remove('footer-freeclass-block');
    //   }
    // }
   
  }

  const setShareLink = () => {

    bridge.callHandler('nativeEvent', {
      event: 'shareLink',
      params: {
        // shareLinkParams:{
        title: `【限时领取】专享9大炒股神器福利`,
        desc: '福利包含“精选研报、短线挖掘、波段助手、红绿波段、趋势拐点、跳空异动。。。”等等10多种权益内容，限时领取。',
        thumbUrl: 'https://file.wogoo.com/app/logo/logo6.png',
        linkUrl: process.env.REACT_APP_DEMAND_URL + shareUrl,
        // }
      }
    })
  }
  console.log(setShareLink);

  useEffect(()=>{
    window.addEventListener('scroll', handleScroll);
    return   window.addEventListener('scroll', null);
  }, [])

  return (
    <div>
      {
        isStorm && <Header 
          title={'新用户专享炒股神器福利'} 
          leftClick={()=> {
            handleLeftClick()
          }}
          right={
            bwmodel.compareVersion('4.17.9') ?( 
            // <img 
            // onClick={()=> {
            //     setShareLink()
            //   }} 
            //   style={{width:'20px','vertical-align': 'middle'}} 
            //   src={bwmodel.theme === '0' ? require(`@/img/share.png`):require(`@/img/share_dark.png`)} 
            //   alt="分享" 
            // />
            ""
              )
          :''
            }
        />
      }
        
      <Container style={{marginTop: isStorm?'44px':'0px'}}>
       <img className="first" src={require('./img/首图@2x.png')} alt="市值风云" />
        <img className="member-img" src={require('./img/权益一@2x.png')} alt="市值风云" />
        <img className="member-img" src={require('./img/权益二@2x.png')} alt="市值风云" />
        <img className="member-img" src={require('./img/权益三@2x.png')} alt="市值风云" />
        <img className="member-img" src={require('./img/权益四@2x.png')} alt="市值风云" />
        <img className="member-img" src={require('./img/权益五@2x.png')} alt="市值风云" />
        <img className="member-img" src={require('./img/权益六@2x.png')} alt="市值风云" />
        <img className="member-img" src={require('./img/权益七@2x.png')} alt="市值风云" />
        <img className="member-img" src={require('./img/权益八@2x.png')} alt="市值风云" />
        <img className="member-img" src={require('./img/权益九@2x.png')} alt="市值风云" />
      <div className="footer footer-freeclass-block" id="footer">
        <div className="tips">新用户首充福利倒计时：<time>{ tips }</time></div>
        <div className="btn" onClick={()=>{
           handleUploadTrace('ActivityPagelyuan_Buy')
           handleUnlock()
        }
          }>
          {/* <div>免费试用7天，解锁全部权益</div>
          <span>原价498元</span> */}
          <div>免费试用3天，解锁全部权益</div>
          <span>原价213元</span>
        </div>
      </div>
      </Container>

      {/* <ModalView
        visible={showModal}
        over
        content={
          <ModalContainer >
            <div className="modalCon" onClick={()=>handleUnlock()}>
              <img  src={require('./img/进入弹窗@2x.png')} alt="市值风云" />
              <div className="tips">
                { tips }
                <time>{ tips }</time>
              </div>
            </div>
            
            <img className="close" onClick={()=>closeModal()} src={closeIcon} alt="市值风云" />
            
          </ModalContainer>
        }
      /> */}

      {
        showModal && 

          <ModalView className="ModalView">
            <div className="bg" onClick={()=>closeModal()} >

            </div>
            <div className="con">
            <ModalContainer >
                <div className="modalCon" onClick={()=>handleUnlock()}>
                  <img  src={require('./img/进入弹窗@2x.png')} alt="市值风云" />
                  <div className="tips">
                    { tips }
                  </div>
                </div>
                
                <img className="close" onClick={()=>closeModal()} src={closeIcon} alt="市值风云" />
                
              </ModalContainer>
              </div>
          </ModalView>
          }
       
    </div>
  )
}


const Container = styled.div`
  // font-size:0;
  background: #011548;
  padding-bottom: 136px;
img {
  vertical-align: middle;
  font-size:0;
  width:100%;
}
 .first {
  //  margin-top: -11vw;
  margin-bottom: -37vw;
 }
  .member-img {
    padding: 0px 4.1vw;
    box-sizing: border-box;
    margin-top: 12px;
  }
    .footer {
      height: 116px;
      background: #041C55;
      // background:#00f;
      box-shadow: 0px 4px 16px 0px rgba(0,0,0,0.1);
       padding: 10px 4.1vw 0px;
       position: fixed;
      left: 0;
      right: 0;
      bottom: -126px;
     
      z-index: 10;
      transition: bottom 0.5s;
      &.footer-freeclass-block {
          bottom: 0;
      }
      .tips{
        padding: 10px;
        color: #FFF;
        text-align:center;
        time {
          color: #FFCD88;
        }
      }
      .btn {
        height: 44px;
        background: linear-gradient( 270deg, #F3BB6D 0%, #F7E2C3 100%);
        border-radius: 8px;
        font-size: 16px;
        color: #894618;
        text-align: center;
        position: relative;
        line-height: 44px;
        
        >span {
          position: absolute;
          right: 0px;
          width: 70px;
          height: 20px;
          background: #FF3446;
          border-radius: 0px 8px 0px 8px;
          color: #FFFFFF;
          text-decoration: line-through;
          top:0px;
          font-size:12px;
          line-height: 17px;
            
        }
      }
    }
@keyframes liuguang {
  00% {
    left: -105px;
  }

  20% {
    left: -15px;
  }
 
 
  100% {
    left: 50vw;
  }
}
`
const ModalContainer = styled.div`
  .modalCon {
      position: relative;
      img {
        width:68.2vw;
      }
    
  }
  .tips {
    color: #FFFFFF;
    position: absolute;
    width:100%;
    text-align:center;
    top: 31vw;
  }
  .close {
    display: block;
    margin: 10px auto 0;
  }
`

const ModalView =  styled.div`
  position: fixed;
  left: 0;
  top: 0;
  overflow: hidden;
  width: 100%;
  height: 100%;
  z-index: 1000;
  display: inline-block;
  .bg {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    background: rgba(0,0,0,0.5);
    z-index: 10;
  }
  .con {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 11;
  }
  
`


const mapStateToProps = (state) => ({
  token: state.user.accessToken
});

export default React.memo(connect(mapStateToProps)(Active_121))


// WEBPACK FOOTER //
// ./src/views/activity_121/index.js